import * as React from "react";
import { SherpaHeader } from "../../components/layout/SherpaHeader";
import { SherpaFooter } from "../../components/layout/SherpaFooter";
import { ApplicationDefaultHome } from "./home";
import { LabSetting } from "./lab-setting";
import { RouteDefinition } from "../../App";

export const commonRoutes: RouteDefinition[] = [
    {
        path: "/",
        content: () => <ApplicationDefaultHome/>,
        header: () => <SherpaHeader headerType="Home"/>,
        footer: () => <SherpaFooter variant="PathFinderHome" />,
        contentClass: "instance-home-no-padding"
    },
    {
        path: "/lab",
        content: () => <LabSetting/>,
        header: () => <SherpaHeader headerType="Home"/>,
        footer: () => <SherpaFooter variant="PathFinderHome" agenticUIOnly />
    }
];